enum AppConfigurationEnum {
  GetmyAnybillAppConfiguration = "GetmyAnybillAppConfiguration",
  TimifyAppConfiguration = "TimifyAppConfiguration",
  EmailMarketingAppConfiguration = "EmailMarketingAppConfiguration",
  VendorBillsArchiveAppConfiguration = "VendorBillsArchiveAppConfiguration",
}

export default AppConfigurationEnum;
